import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import moment from "moment";
import { SecEventType } from "../../../domain/sec-events";

@Component({
  selector: "evrideo-calendar-grid-sec-events-popup",
  templateUrl: "./calendar-grid-sec-events-popup.component.html",
  styleUrls: ["./calendar-grid-sec-events-popup.component.scss"],
})
export class CalendarGridSecEventsPopupComponent implements OnInit {
  @Input() secEvents;

  @Output() viewOptionChange = new EventEmitter<string>();

  audioTracks;
  subtitles;
  closedCaptions;
  timedEvents;
  secEventType = SecEventType;
  imagesAndTitlesByType = {
    [SecEventType.Cuetone]: {
      title: "Cuetone",
      image: "/assets/icons/cuetone.svg",
    },
    [SecEventType.SCTE]: { title: "SCTE", image: "/assets/icons/SCTE.svg" },
    [SecEventType.Autopilot]: {
      title: "Autopilot",
      image: "/assets/icons/autopilot-icon.svg",
    },
    [SecEventType.Graphics]: {
      title: "Graphics",
      image: "/assets/icons/graphics.svg",
    },
    [SecEventType.FloatingMedia]: {
      title: "Floating Media",
      image: "/assets/icons/floating-media.svg",
    },
  };

  constructor() {}

  ngOnInit(): void {
    this.mapSecEvents();
  }

  mapSecEvents() {
    this.audioTracks = this.secEvents.filter(
      (event) => event.type === SecEventType.Audio,
    );
    this.subtitles = this.secEvents.filter(
      (event) => event.type === SecEventType.Subtitles,
    );
    this.closedCaptions = this.secEvents.filter(
      (event) => event.type === SecEventType.ClosedCaptions,
    );
    this.timedEvents = this.secEvents.filter(
      (event) =>
        event.type !== SecEventType.Audio &&
        event.type !== SecEventType.Subtitles &&
        event.type !== SecEventType.ClosedCaptions,
    );
  }

  formatTime(time): string {
    return moment(moment.duration(time).valueOf()).format("HH:mm:ss");
  }

  onViewOptionChange(): void {
    this.viewOptionChange.emit("list");
  }
}
